// test870
(870 && 0);
